import { render, staticRenderFns } from "./FestivalEvent.vue?vue&type=template&id=c4612990"
import script from "./FestivalEvent.vue?vue&type=script&lang=js"
export * from "./FestivalEvent.vue?vue&type=script&lang=js"
import style0 from "./FestivalEvent.vue?vue&type=style&index=0&id=c4612990&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4612990')) {
      api.createRecord('c4612990', component.options)
    } else {
      api.reload('c4612990', component.options)
    }
    module.hot.accept("./FestivalEvent.vue?vue&type=template&id=c4612990", function () {
      api.rerender('c4612990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FestivalEvent.vue"
export default component.exports